import { render, staticRenderFns } from "./Coordinates.vue?vue&type=template&id=5617f13f"
import script from "./Coordinates.vue?vue&type=script&lang=js"
export * from "./Coordinates.vue?vue&type=script&lang=js"
import style0 from "./Coordinates.vue?vue&type=style&index=0&id=5617f13f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports